module.exports = __webpack_public_path__ + "static/media/linearrow_2.dd741674.png";